module.exports = __webpack_public_path__ + "static/media/email.79b04374.png";